import State from './interface';

export default <State>{
    overlay: {
        currentPanel: '',
        currentSubPanel: 1,
    },
};
